import * as React from "react"

export const PowerIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.004 11a.53.53 0 0 1-.387-.156.52.52 0 0 1-.159-.386V3.894a.526.526 0 0 1 .538-.541q.228 0 .387.155a.52.52 0 0 1 .159.386v6.564a.526.526 0 0 1-.538.542m-.003 5.583q-1.35 0-2.553-.518a6.7 6.7 0 0 1-2.096-1.409 6.7 6.7 0 0 1-1.415-2.088 6.3 6.3 0 0 1-.52-2.547q0-1.346.533-2.57a6.75 6.75 0 0 1 1.51-2.169.6.6 0 0 1 .409-.176.52.52 0 0 1 .397.16.46.46 0 0 1 .145.395.6.6 0 0 1-.21.382 5.1 5.1 0 0 0-1.276 1.819A5.6 5.6 0 0 0 4.5 10.02q0 2.27 1.6 3.875T9.995 15.5t3.9-1.604Q15.5 12.29 15.5 10.02q0-1.123-.442-2.16a5.4 5.4 0 0 0-1.268-1.816.6.6 0 0 1-.207-.392.47.47 0 0 1 .154-.394.5.5 0 0 1 .395-.157q.23.01.411.176a6.3 6.3 0 0 1 1.518 2.165 6.55 6.55 0 0 1 .522 2.578q0 1.35-.52 2.547a6.7 6.7 0 0 1-1.415 2.088 6.7 6.7 0 0 1-2.096 1.41 6.4 6.4 0 0 1-2.551.517"
    ></path>
  </svg>
)
